import AuthApi from '@/api/auth.api.ts';

export function isTwoObjEqual(obj1, obj2) {
    return JSON.stringify(obj1) === JSON.stringify(obj2)
}

export function isEmpty(value) {
    return value === '' || value === null || value === undefined;
}

export const groupBy = (x, f) => x.reduce((a, b, i) => ((a[f(b, i, x)] ||= []).push(b), a), {});

export function generateRandomID() {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let result = '';
    for (let i = 0; i < charactersLength; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
}

export async function isEmailUnique(value) {
    if (!value) return true;

    let emailIsTaken;

    await AuthApi.checkEmailExisting(value)
        .then(({data}) => {
            emailIsTaken = data.exists;
        });

    return !emailIsTaken;
}

export function isNullOrEmpty(value) {
    if (value == null || value === '') {
        return true;
    }

    if (typeof value === 'object') {
        if (Array.isArray(value)) {
            return value.length === 0;
        } else {
            return Object.keys(value).length === 0;
        }
    }

    return false;
}

export function deepClone(value) {
    return JSON.parse(JSON.stringify(value));
}

export function addLeadingZero(value) {
    return value < 10 ? `0${value}` : value;
}

export function replaceAll(str, find, replace) {
    return str.replace(new RegExp(find, 'g'), replace);
}

export function inputNumbersOnly(event) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        return event.preventDefault();
    }
    return true;
}

export function arrayOfObjectsToObject(array, keyProperty) {
    const data = deepClone(array);
    const obj = {};

    data.forEach((item) => {
        let key = item[keyProperty];
        delete item[keyProperty];
        obj[key] = {
            ...item,
        };
    })

    return obj;

}

export function validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;
    const domainPart = email.split('@')[1];
    if (domainPart && (domainPart.startsWith('.') || domainPart.endsWith('.'))) {
        return false;
    }
    return emailRegex.test(email);
}

/**
 * Преобразует ссылки в тексте в HTML-теги <a> с target="_blank"
 * @param {string} text - Текст для обработки
 * @returns {string} - HTML строка с активированными ссылками
 */
export function activateLinksInText(text) {
    if (!text || typeof text !== 'string') {
        return text || '';
    }

    // Регулярное выражение для поиска URL (http://, https://, www.)
    const urlRegex = /(https?:\/\/[^\s<>"']+)|(www\.[^\s<>"']+)/gi;
    
    // Разбиваем текст на части, сохраняя позиции URL
    const parts = [];
    let lastIndex = 0;
    let match;

    while ((match = urlRegex.exec(text)) !== null) {
        // Добавляем текст до URL с экранированием
        if (match.index > lastIndex) {
            const textBefore = text.substring(lastIndex, match.index);
            parts.push({
                type: 'text',
                content: escapeHtml(textBefore)
            });
        }

        // Обрабатываем URL
        let url = match[0];
        let displayUrl = match[0];
        
        // Если ссылка начинается с www., добавляем http://
        if (url.toLowerCase().startsWith('www.')) {
            url = 'http://' + url;
        }
        
        // Проверяем, что URL валидный
        try {
            new URL(url);
            // URL в href не экранируем (браузер сам обработает), но экранируем отображение
            parts.push({
                type: 'link',
                url: url.replace(/"/g, '&quot;'), // Только кавычки для атрибута
                display: escapeHtml(displayUrl)
            });
        } catch (e) {
            // Если URL невалидный, экранируем как обычный текст
            parts.push({
                type: 'text',
                content: escapeHtml(match[0])
            });
        }

        lastIndex = match.index + match[0].length;
    }

    // Добавляем оставшийся текст после последнего URL
    if (lastIndex < text.length) {
        parts.push({
            type: 'text',
            content: escapeHtml(text.substring(lastIndex))
        });
    }

    // Если не было найдено URL, просто экранируем весь текст
    if (parts.length === 0) {
        return escapeHtml(text);
    }

    // Собираем результат
    return parts.map(part => {
        if (part.type === 'link') {
            return `<a href="${part.url}" target="_blank" rel="noopener noreferrer">${part.display}</a>`;
        }
        return part.content;
    }).join('');
}

/**
 * Экранирует HTML-символы для безопасности
 * @param {string} text - Текст для экранирования
 * @returns {string} - Экранированный текст
 */
function escapeHtml(text) {
    if (!text) return '';
    return text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
}
